import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { SafePipeModule } from 'safe-pipe';
import { SharedModule } from "../shared/shared.module";
import { ApgOpenBankingInstitutionsComponent } from "./apg-open-banking-institutions/apg-open-banking-institutions.component";
import { ApgOpenBankingComponent } from "./apg-open-banking.component";
import { ApgOpenBankingPaymentComponent } from "./apg-open-banking-payment/apg-open-banking-payment.component";
import { ApgOpenBankingSavingsComponent } from "./apg-open-banking-savings/apg-open-banking-savings.component";
import { ApgOpenBankingTransactionsComponent } from "./apg-open-banking-transactions/apg-open-banking-transactions.component";
import { ApgOpenBankingAffordabilityComponent } from "./apg-open-banking-affordability/apg-open-banking-affordability.component";
import { ApgSelectPremiumDayComponent } from "./apg-open-banking-affordability/apg-select-premium-day/apg-select-premium-day.component";
import { QuestionsModule } from "../questions/questions.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    SafePipeModule,
    QuestionsModule
  ],
  exports: [ApgOpenBankingComponent],
  declarations: [
    ApgOpenBankingComponent,
    ApgOpenBankingInstitutionsComponent,
    ApgOpenBankingPaymentComponent,
    ApgOpenBankingSavingsComponent,
    ApgOpenBankingTransactionsComponent ,
    ApgOpenBankingAffordabilityComponent,
    ApgSelectPremiumDayComponent
  ]
})

export class ApgOpenBankingModule {

}
